import { Core } from "@faire/design-tokens";
import { FormikInput } from "@faire/retailer-visitor-shared/components/Form/FormikInput";
import { IFormikInputIProps } from "@faire/retailer-visitor-shared/components/Form/types";
import { Eye, EyeClosed } from "@faire/web/slate/icons/foundation/Eye";
import { useState } from "@faire/web/ui/hooks/useState";
import React from "react";

export const FormikPassword: React.FC<
  IFormikInputIProps & {
    shouldShowEyeButton?: boolean;
  }
> = ({ trackChange, shouldShowEyeButton, ...props }) => {
  const [showPassword, setShowPassword] = useState(false);
  const suffixNode = shouldShowEyeButton ? (
    <button
      type="button"
      data-test-id="eye-button"
      onClick={() => {
        setShowPassword(!showPassword);
      }}
    >
      {showPassword ? (
        <Eye color={Core.text.subdued} fontSize="24px" />
      ) : (
        <EyeClosed color={Core.text.subdued} fontSize="24px" />
      )}
    </button>
  ) : null;
  return (
    <FormikInput
      {...props}
      type={showPassword ? "text" : "password"}
      trackChange={(name) => trackChange?.(name, "")}
      suffixNode={suffixNode}
    />
  );
};
